import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ISignatureProviderComponent } from '../isignatureprovidercomponent';

@Component({
    selector: 'app-no-signature-provider',
    templateUrl: './no-signature-provider.component.html',
    styleUrls: [],
    standalone: false
})
export class NoSignatureProviderComponent implements ISignatureProviderComponent {
  static readonly NAME = 'none';
  static readonly LABEL = 'None';
  private readonly _formGroup: UntypedFormGroup;

  constructor() {
    this._formGroup = new UntypedFormGroup({});
  }

  get name() {
    return NoSignatureProviderComponent.NAME;
  }

  get formGroup() {
    return this._formGroup;
  }

  initialiseForm(signature: any): UntypedFormGroup {
    return this.formGroup;
  }
}
